module.exports = __webpack_public_path__ + "img/tintuc27.ec0c8af9.png";